module.exports = __webpack_public_path__ + "static/img/8496_phase_function_Paper_Points.82d6437.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/8496_phase_function_Paper_Points.png
// module id = p5DL
// module chunks = 0